export default __webpack_public_path__ + "static/media/vehicle_maintenance.d25a170a.png";